import { Pricing, Product, ProductColumnsIds } from '@setvi/shared/interfaces';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { Cost, Discount, Price, Profit } from './index';

interface PricingProps {
  product: Product;
  pricing: Pricing;
  fontSize?: STextProps['size'];
}

export const getGridProductDetailsPricing = ({
  pricing,
  product,
  fontSize
}: PricingProps) => {
  const content = {
    [ProductColumnsIds.Price]: (
      <Price label={pricing.label} value={product?.price} size={fontSize} />
    ),
    [ProductColumnsIds.Cost]: (
      <Cost label={pricing.label} value={product?.cost} size={fontSize} />
    ),
    [ProductColumnsIds.CustomerCost]: (
      <Cost label={pricing.label} value={product?.cost} size={fontSize} />
    ),
    [ProductColumnsIds.GP]: (
      <Profit
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
        size={fontSize}
      />
    ),
    [ProductColumnsIds.Discount]: (
      <Discount
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
        size={fontSize}
      />
    )
  };

  return content[pricing.id];
};
